'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'

import fukkuStyles from 'fukku/styles/classes.module.scss'
import styles from './OrderId.module.scss'

interface OrderIdProps {
	readonly orderId: string
	readonly type?: ORDER_TYPES
}

export function OrderId({ orderId, type }: OrderIdProps) {
	const { t } = useLabels()
	const orderInfoKey =
		type === ORDER_TYPES.STORE
			? t('my_purchases.receipt_number')
			: t('myPurchases.list.order.text')
	const orderTypeA11yKey =
		type === ORDER_TYPES.STORE
			? 'accessibility.myPurchases.ticketNumber.text'
			: 'accessibility.myPurchases.orderNumber.text'

	return (
		<p
			data-testid={`myPurchases.purchaseCard.purchaseNumber.${orderId}`}
			className={styles.purchaseNumber}
		>
			<span aria-hidden>{orderInfoKey}</span>{' '}
			<span aria-hidden className={styles.orderId}>
				{orderId}
			</span>
			<span className={fukkuStyles.srOnly}>
				{`${t(orderTypeA11yKey)} ${orderId}`}
			</span>
		</p>
	)
}
